import { useRef as l, useState as b, useCallback as f, useEffect as T, useMemo as L } from "react";
const v = (e) => typeof e == "number" ? e : +new Date(e) - +/* @__PURE__ */ new Date(), y = ({
  date: e,
  interval: r = 1e3,
  autostart: c = !0,
  onEnd: n,
  onTick: t
}) => {
  const s = l(e), u = l(v(e)), [i, m] = b(u.current), o = l({ onTick: t, onEnd: n }), a = l(), p = f(() => {
    a.current && (clearInterval(a.current), a.current = void 0);
  }, []), D = f(() => {
    m((R) => {
      const w = Math.max(R - r, 0);
      return w <= 0 && (p(), o.current.onEnd && o.current.onEnd()), w;
    }), o.current.onTick && o.current.onTick();
  }, [r, p]), d = f(
    (R) => {
      const w = v(R ?? u.current);
      m(w), a.current && clearInterval(a.current), w > 0 ? a.current = setInterval(D, r) : o.current.onEnd && o.current.onEnd();
    },
    [r, D]
  ), M = f(() => p(), [p]), _ = f(() => d(), [d]), I = f((R) => {
    u.current = R || u.current, m(u.current);
  }, []), C = f(() => {
    p(), m(0);
  }, [p]);
  T(() => {
    c && d();
  }, [c, d]), T(() => {
    s.current = e;
    const R = v(e);
    u.current !== R && I(R);
  }, [e, I]), T(() => {
    o.current = {
      onEnd: n,
      onTick: t
    };
  }, [n, t]), T(() => () => p(), [p]);
  const N = L(
    () => ({ start: d, pause: M, resume: _, reset: C, restart: I }),
    [M, C, _, d, I]
  );
  return [i, u.current, N];
}, F = (e, r, { toValues: c, fromValues: n } = {}) => {
  const t = L(
    // memoize defaults
    () => c ? c(r, e) : { ...r, ...e },
    [r, e, c]
  ), s = f(
    (u, i) => n ? n(t, u, i) : { ...u, ...i },
    [t, n]
  );
  return { defaultValues: t, toData: s };
}, g = () => {
  const e = l(!0);
  return T(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}, E = (e) => {
  e != null && e._timer && clearTimeout(e._timer);
}, x = {
  clearTimer: E,
  remove: (e, r, c) => {
    if (!c[e]) return r;
    const n = r.findIndex((s) => s.id === e);
    if (n === -1) return r;
    const t = [...r];
    return E(t[n]), t.splice(n, 1), delete c[e], t;
  },
  add: (e, r, c = 3500, n, t, s) => {
    if (t[e]) return n;
    const u = c ? setTimeout(() => s(e), c) : void 0;
    return t[e] = !0, [
      ...n,
      {
        id: e,
        timeout: c,
        _timer: u,
        data: r
      }
    ];
  },
  replace: (e, r, c = 3500, n, t, s) => {
    t[e] && s(e);
    const u = c ? setTimeout(() => s(e), c) : void 0;
    return t[e] = !0, [
      ...n,
      {
        id: e,
        timeout: c,
        _timer: u,
        data: r
      }
    ];
  }
}, P = () => {
  const e = g(), r = l({}), [c, n] = b([]), t = f(
    (i) => {
      e.current && n((m) => x.remove(i, m, r.current));
    },
    [e]
  ), s = f(
    (i, m, o = 3500) => {
      n(
        (a) => x.add(i, m, o, a, r.current, t)
      );
    },
    [t]
  ), u = f(
    (i, m, o = 3500) => {
      n(
        (a) => x.replace(i, m, o, a, r.current, t)
      );
    },
    [t]
  );
  return { notifications: c, add: s, remove: t, replace: u };
}, S = (e) => {
  const r = l();
  return T(() => {
    r.current = e;
  }, [e]), r.current;
}, h = (e) => {
  const r = l(e);
  return T(() => {
    r.current = e;
  }, [e]), r;
};
export {
  x as notificationManager,
  y as useCountdown,
  F as useFormValues,
  g as useMountedRef,
  P as useNotifications,
  S as usePrevious,
  h as useRefCallback
};
